export const Actions = {
  LIST_VEHICLE_TYPES: "LIST_VEHICLE_TYPES",
  LIST_VEHICLE_TYPES_SUCCEEDED: "LIST_VEHICLE_TYPES_SUCCEEDED",
};
